const TAB_TO_SLUG = {
  "matter-workspace": "matter-workspace",
  certification: "certification",
  "aid-form": "aidapplication",
  "apply-aid": "applyforaid",
  intake: "intake",
  authority: "authority",
  backsheet: "backsheet",
  "medical-worksheet": "medicalworksheet",
  "memo-precedent": "memoprecedent",
  "additional-prep": "additionalprepworksheet",
  "travel-claim": "travelclaim",
  "submitted-invoices": "submittedinvoices",
  "conflict-check": "conflictcheck",
  inbox: "inbox",
  "weekly-summary": "weekly-summary",
  billing: "billing",
  "aid-diary": "aid-diary",
  "aid-planner": "aid-planner",
  "lacw-aid-planner": "lacw-aid-planner",
  "aid-extension-flowchart": "aid-extension-flowchart",
  "diary-codes": "diary-codes",
  "reminders-guide": "reminders-guide",
  "training-guide": "training-guide",
  "deadline-guard": "deadline-guard",
  "lacw-client-account": "lacw-client-account",
  "vals-client-account": "vals-client-account",
  "eas-client-account": "eas-client-account",
  "audit-logs": "audit-logs",
  "appeal-cost-certificate": "appealcostcertificate",
  "lacw-appeal-cost-certificate": "lacw-appealcostcertificate",
  "vals-appeal-cost-certificate": "vals-appealcostcertificate",
  "eas-appeal-cost-certificate": "eas-appealcostcertificate",
  dashboard: "dashboard",
  "lacw-emails": "emails",
  "vals-emails": "emails",
  "rga-emails": "emails",
  "eas-emails": "emails",
  "fee-slip-invoice-payment": "feeslipinvoicepayment",
  "lacw-fee-slip-invoice-payment": "lacw-feeslipinvoicepayment",
  "monthly-trust-receipts": "monthlytrustreceipts",
  "rga-trust-receipts": "rgatrustreceipts",
  "vals-trust-receipts": "valstrustreceipts",
  "eas-trust-receipts": "eastrustreceipts",
  "draft-forms": "draftforms",
  "vals-diary": "diary",
  "eas-diary": "diary",
  "staff-calendar": "staff-calendar",
  "lacw-staff-calendar": "lacw-staff-calendar",
  "outlook-mail": "outlook-mail",
  "actionstep-simulator": "actionstep-simulator",
  "atlas-simulator": "atlas-simulator",
  "atlas-letter-downloader": "atlas-letter-downloader",
  "lacw-trust-receipts": "lacwtrustreceipts",
  "rga-fee-slip-invoice-payment": "rgafeeslipinvoicepayment",
  "vals-fee-slip-invoice-payment": "valsfeeslipinvoicepayment",
  "eas-fee-slip-invoice-payment": "easfeeslipinvoicepayment",
};

const ADMIN_TAB_TO_SLUG = {
  // A firm reaches its diary at /vals-diary, so the plain slug would collide with the
  // firm's own route. The admin page has its own.
  "vals-diary": "vals-diary",
  "eas-diary": "eas-diary",
  "lacw-emails": "lacwemails",
  "vals-emails": "valsemails",
  "rga-emails": "rgaemails",
  "eas-emails": "easemails",
  // Emma (23 Oct 2026): the address should say what the page is. The old
  // /admin-valstrustreceipts redirects here (src/App.jsx).
  "vals-trust-receipts": "valsdisbursements",
};

export function getPortalToolPath(brand, tabId) {
  const slug =
    brand === "admin" && ADMIN_TAB_TO_SLUG[tabId]
      ? ADMIN_TAB_TO_SLUG[tabId]
      : TAB_TO_SLUG[tabId] || tabId;
  return `/${brand}-${slug}`;
}

// The reverse of getPortalToolPath, for the browser's Back and Forward buttons: which of
// `tabIds` the address shows. "/<brand>-portal" is the portal home. Several firms' tabs
// share a slug ("emails"), so only the tabs this portal has are considered.
export function getPortalTabFromPath(brand, pathname, tabIds) {
  const path = String(pathname || "").toLowerCase().replace(/\/+$/, "");
  if (path === `/${brand}-portal`) return "dashboard";
  return tabIds.find((tabId) => getPortalToolPath(brand, tabId).toLowerCase() === path) || null;
}
